import React from 'react';
import PropTypes from 'prop-types';

import { default as MuiRadio } from '@material-ui/core/Radio';

import { Text, StyledCard, StyledCardContent } from '../../../components/index';

import {
    useStylesRadio,
    StyledTypeContainer,
    StyledRadioContainer,
    StyledRadioTextContainer,
} from './style';

const SessionTypeCard = ({ selectedValue, onChange, disabled }) => {
    const classes = useStylesRadio();

    return (
        <StyledCard>
            <StyledCardContent style={{ display: 'flex', flexDirection: 'column', rowGap: '10px' }}>
                <Text $bold $fontSize="20px">
                    Session Type
                </Text>
                <StyledTypeContainer>
                    <StyledRadioContainer
                        onClick={() => {
                            if (disabled) return;
                            onChange('public');
                        }}
                        disabled={disabled}
                    >
                        <MuiRadio
                            checked={selectedValue === 'public'}
                            value="public"
                            name="sessionTypeRadio"
                            inputProps={{ 'aria-label': 'radio public' }}
                            className={classes.root}
                            disabled={disabled}
                        />
                        <StyledRadioTextContainer>
                            <Text $medium>Public Session</Text>
                            <Text $fontSize="12px">
                                At vero eos et accusamus et iusto odio dignissimos ducimus qui
                                blanditiis praesentium
                            </Text>
                        </StyledRadioTextContainer>
                    </StyledRadioContainer>
                    <StyledRadioContainer
                        onClick={() => {
                            if (disabled) return;
                            onChange('invite');
                        }}
                        disabled={disabled}
                    >
                        <MuiRadio
                            checked={selectedValue === 'invite'}
                            value="invite"
                            name="sessionTypeRadio"
                            inputProps={{ 'aria-label': 'radio invite' }}
                            className={classes.root}
                            disabled={disabled}
                        />
                        <StyledRadioTextContainer>
                            <Text $medium>Invitation Only</Text>
                            <Text $fontSize="12px">
                                At vero eos et accusamus et iusto odio dignissimos ducimus qui
                                blanditiis praesentium
                            </Text>
                        </StyledRadioTextContainer>
                    </StyledRadioContainer>
                </StyledTypeContainer>
            </StyledCardContent>
        </StyledCard>
    );
};

SessionTypeCard.propTypes = {
    selectedValue: PropTypes.string,
    onChange: PropTypes.func,
};

export default SessionTypeCard;
